import PageHeader from "@/components/PageHeader";
import { useAuth } from "@/contexts/AuthContext";
import { ExternalLink } from "lucide-react";
import { useEffect, useRef } from "react";

export const HAWKE_EYE_URL = process.env.REACT_APP_HAWKE_EYE_URL || "https://signin-watchdog.emergent.host";

export default function HawkeEye() {
  const { user } = useAuth();
  const launchedRef = useRef(false);
  const activeOrgName = (user?.organization_name || "").replace(/[–—]/g, "-").toLowerCase().trim();
  const isRheelInternal = activeOrgName === "rheel group - internal";

  const launch = () => window.open(HAWKE_EYE_URL, "_blank", "noopener,noreferrer");

  useEffect(() => {
    if (!isRheelInternal || launchedRef.current) return;
    launchedRef.current = true;
    launch();
  }, [isRheelInternal]);

  if (!isRheelInternal) {
    return (
      <div data-testid="hawke-eye-page">
        <PageHeader
          eyebrow="[12] 365 Hawke Eye"
          title="365 Hawke Eye"
          subtitle="Available only from the Rheel Group – Internal organization."
        />
        <div className="p-4 sm:p-6 lg:p-8">
          <div data-testid="hawke-eye-restricted" className="border border-[#E5E0D5] bg-white p-8 max-w-xl">
            <div className="uppercase-label text-[#B45309] mb-2">Restricted view</div>
            <p className="text-sm text-[#3A3A3A]">
              365 Hawke Eye is Rheel&apos;s internal sign-in watchdog portal and is only visible when the
              <strong> Rheel Group – Internal</strong> organization is selected in the sidebar.
              Switch organizations to access it.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="hawke-eye-page">
      <PageHeader
        eyebrow="[12] 365 Hawke Eye"
        title="365 Hawke Eye"
        subtitle="Microsoft 365 sign-in watchdog portal. Uses its own login and MFA."
      />
      <div className="p-4 sm:p-6 lg:p-8">
        <div
          data-testid="hawke-eye-launching"
          className="border border-[#E5E0D5] bg-white p-10 max-w-xl flex flex-col items-start gap-4"
        >
          <div className="uppercase-label text-[#5A5A5A]">Launching</div>
          <p className="text-lg text-[#0F0F0F] font-medium tracking-tight">
            Launching 365 Security Hawke Eye in a new Tab
          </p>
          <p className="text-sm text-[#5A5A5A]">
            If the new tab didn&apos;t open, your browser may have blocked the pop-up. Use the button below to launch it.
          </p>
          <button
            type="button"
            data-testid="hawke-eye-launch-btn"
            onClick={launch}
            className="inline-flex items-center gap-2 rounded-none bg-[#F37B2A] hover:bg-[#D86A1F] text-white font-mono text-xs tracking-wider uppercase px-4 py-2.5"
          >
            <ExternalLink className="w-3.5 h-3.5" /> Launch Hawke Eye
          </button>
        </div>
      </div>
    </div>
  );
}
